const isBrowser = () => typeof window !== 'undefined';

export const readLocalStorageItem = (key: string): string | null => {
  if (!isBrowser()) return null;

  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeLocalStorageItem = (key: string, value: string): void => {
  if (!isBrowser()) return;

  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage can be unavailable in private mode or blocked browser contexts.
  }
};
